'use client';

import { c as _c } from "react/compiler-runtime";
import { StatsCard } from '@/shared/components/ui';
import { FeatherActivity, FeatherAlertCircle, FeatherFlame, FeatherSnowflake } from '@subframe/core';
import type { LoteStatsProps } from '../../types/lote.types';
export function LoteStats(t0) {
  const $ = _c(37);
  const {
    metrics,
    onSectionClick
  } = t0;
  let t1;
  if ($[0] !== onSectionClick) {
    t1 = () => onSectionClick("INTERVENTION");
    $[0] = onSectionClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FeatherActivity className="text-brand-600 h-5 w-5" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== metrics.total) {
    t3 = <StatsCard label={"Total de Negocia\xE7\xF5es"} value={metrics.total} icon={t2} className="hover:border-brand-500" />;
    $[3] = metrics.total;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <div className="cursor-pointer transition-transform hover:scale-[1.02]" onClick={t1}>{t3}</div>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onSectionClick) {
    t5 = () => onSectionClick("INTERVENTION");
    $[8] = onSectionClick;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FeatherAlertCircle className="text-warning-600 h-5 w-5" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== metrics.intervention) {
    t7 = <StatsCard label={"Interven\xE7\xE3o Humana"} value={metrics.intervention} icon={t6} className="hover:border-warning-500" />;
    $[11] = metrics.intervention;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7) {
    t8 = <div className="cursor-pointer transition-transform hover:scale-[1.02]" onClick={t5}>{t7}</div>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== onSectionClick) {
    t9 = () => onSectionClick("HOT");
    $[16] = onSectionClick;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FeatherFlame className="text-error-600 h-5 w-5" />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== metrics.hot) {
    t11 = <StatsCard label="Temperatura Quente" value={metrics.hot} icon={t10} className="hover:border-error-500" />;
    $[19] = metrics.hot;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t9) {
    t12 = <div className="cursor-pointer transition-transform hover:scale-[1.02]" onClick={t9}>{t11}</div>;
    $[21] = t11;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== onSectionClick) {
    t13 = () => onSectionClick("COLD");
    $[24] = onSectionClick;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <FeatherSnowflake className="text-information-600 h-5 w-5" />;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== metrics.cold) {
    t15 = <StatsCard label="Temperatura Fria" value={metrics.cold} icon={t14} className="hover:border-information-500" />;
    $[27] = metrics.cold;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t13 || $[30] !== t15) {
    t16 = <div className="cursor-pointer transition-transform hover:scale-[1.02]" onClick={t13}>{t15}</div>;
    $[29] = t13;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t12 || $[33] !== t16 || $[34] !== t4 || $[35] !== t8) {
    t17 = <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">{t4}{t8}{t12}{t16}</div>;
    $[32] = t12;
    $[33] = t16;
    $[34] = t4;
    $[35] = t8;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  return t17;
}